export default __webpack_public_path__ + "static/media/office-briefcase.03f70a4e.svg";